$( document ).ready(function() {

listing.init();
LayoutFilter.init();
mobilemenu.init();
team.init();
confirmation.init();

    // Adding Jquery UI to dropdowns
    $('.ginput_container select').selectmenu();

    //  Function to add script class to text with <em>
    $('em').addClass('script');

    //Function to add class to footer menu on Mobile
    // if( $(window).width() < 768) {
    //     $()
    // }

    //  Function to add hover class to card-links on hover
    $( ".card-link" ).hover(
        function() {
            $( '.card-content', this ).addClass( "hover" );
        }, function() {
            $( '.card-content', this).removeClass( "hover" );
        }
    );

    //Function to add header class to team page
    if($('div.layout').hasClass('team-slider')) {
        $('nav').addClass('dark');
        // $('.hamburger').addClass('dark');
        $('.header').addClass('team-page');
    }

    //Set the height of the post-image to be the same as the calculated width
    if ($(window).width() > 1024) {
        $('.post-image').height($('.post-image').width());
    }


    //Function to add logo to footer menu
    $('.menu-logo a').addClass('logo').html('<img src="http://bdastesting.com/app/themes/mightily/app/assets/img/logo.svg" />');

    // Also can pass in optional settings block
    if ( $('.rellax').length ) {
         var rellax = new Rellax('.rellax', {
         	speed: 3,
         	center: true,
         });
    }
   

    AOS.init();


});
